import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ControlValueAccessorDirective } from '../../../Helpers/Directives/controlValueAccessor.directive';

@Component({
  selector: 'input-feild',
  templateUrl: 'inputFeild.component.html',
  styleUrls: ['inputFeild.component.scss'],
})
export class InputFeildComponent extends ControlValueAccessorDirective {
  @Input() public label: string | null = null;
  @Input() public control!: FormControl ;
  @Input() public isSubmitted: boolean = false;
  @Input() isProjectedContentIsSelect = false
  @Input() public datePickerStyle: boolean = false;

  public get Required(): boolean {
    return this.control?.hasValidator(Validators.required) ;
  }

  public get Invalid(): boolean {
    return this.control.invalid ;
  }

  public get ShowError(): boolean {
    if (!this.control) return false;
    const { dirty, touched } = this.control;
    return this.Invalid ? dirty || touched || this.isSubmitted : false;
  }
}
